import { mapActions, mapGetters, mapState } from 'vuex';
import { getImpersonateData, saveImpersonateData } from '~/helpers/_core/impersonate';

export default {
  computed: {
    ...mapGetters({
      isImpersonated: '_core/auth/isImpersonated'
    }),
    ...mapState({
      impersonatedBy : (state) => state._core.auth.impersonatedBy,
      userName       : (state) => state._core.user.name
    })
  },
  beforeMount() {
    const impersonate = getImpersonateData({ store: this.$store });

    if (impersonate?.redirect && this.isImpersonated) {
      this.$router.push(impersonate.redirect);
      saveImpersonateData({
        payload: {
          ...impersonate,
          redirect: null
        },
        store: this.$store
      });
    }
  },
  methods: {
    ...mapActions({
      actionSignOutImpersonate: '_core/auth/actionSignOutImpersonate'
    }),
    async logout() {
      await this.actionSignOutImpersonate();
    }
  }
};
